import classnames from 'classnames/bind';
import { FC, memo, PropsWithChildren } from 'react';
import styles from './Container.module.scss';

const cx = classnames.bind(styles);

export const Container: FC<PropsWithChildren> = memo(({ children }) => {
  return <div className={cx(styles['container'])}>{children}</div>;
});
Container.displayName = 'ReconciliationServiceSettingContainer';
